(function () {
  angular.module('binky.core.lodash', []);
})();
